import React from "react";
import ProjectRepository from "../../repository/ProjectRepository";
import StandardFormComponent from "../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../basics/FormToastComponent";
import FormHelper from "../../helpers/FormHelper";
import CheckPermissions from "../../helpers/CheckPermissions";
import UserRolesEnum from "../../enums/UserRolesEnum";
import ProjectTextFormComponent from "./forms/ProjectTextFormComponent";
import Module from "../../models/module/Module";
import Project from "../../models/project/Project";
import { ModuleRepository } from "../../repository";
import ProjectContent from "../../models/project/ProjectContent";
import { LoaderComponent } from "../basics/layout";

class ProjectAddFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model !== undefined ? this.props.model : new ProjectContent(),
            loading: true,
            settings: {},
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.table_ref = React.createRef();

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [
            ModuleRepository.getSettings()
        ];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                let settingsResult = result[0];
                let settings = {};
                if (settingsResult !== undefined && settingsResult.data !== undefined) {
                    settings = settingsResult.data.settings;
                }

                let model = this.state.model;
                if (result[1] !== undefined) {
                    model = Project.fromJson(result[1].project);
                    let content = model.contents.filter(content => content.language === this.props.match.params.language)[0];

                    model.title = content.title;
                    model.client = content.client;
                    model.url = content.url;
                    model.summary = content.summary;
                    model.content = content.content === '[]' ? {} : JSON.parse(content.content);
                }

                this.setState({
                    loading: false,
                    settings: settings,
                    model: model,
                    isEdit: model.id
                });
            });
    }

    getBeforeSubmit = (element) => ProjectTextFormComponent.fields_image_before_submit(element)

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                ref={this.table_ref}
                parent={this}
                className={"project"}
                validationSchema={Project.schema(this.state.settings)}
                model={this.state.model}
                formSubmit={(values, formikActions) => {
                    this.getBeforeSubmit.bind();
                    return this.getBeforeSubmit(this.table_ref.current)
                        .then(() => {
                            if (this.state.isEdit) {
                                return ProjectRepository.update({ id: values.id, language: this.props.match.params.language, ...values })
                                    .then(() => {
                                        FormToastComponent.successTrans("Project", "Default.saved");
                                        this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
                                    })
                                    .catch(error => {
                                        FormHelper.handleSubmitError(this, error)
                                    })
                            } else {
                                return ProjectRepository.create(values)
                                    .then(() => {
                                        FormToastComponent.successTrans("Project", "Default.saved");
                                        this.props.history.push('/module/' + this.props.slug + '/' + Module.getId() + '/overview');
                                    })
                                    .catch(error => {
                                        FormHelper.handleSubmitError(this, error)
                                    })
                            }
                        });
                }}
                formErrors={this.state.form_errors}
                fields={ProjectTextFormComponent.fields(this.state.settings)}
            />
        );
    }
}

export default withRouter(ProjectAddFormComponent);